import script from "./CustomCheckBox.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomCheckBox.vue?vue&type=script&setup=true&lang=js"

import "./CustomCheckBox.vue?vue&type=style&index=0&id=721d6a83&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-721d6a83"]])

export default __exports__